import { PropsWithChildren } from 'react'
import { ApiClientContextProvider } from '../../core'
import { ApiClientInitOptions, useApiClientInit } from '../hooks'

export type ApiClientProviderProps = ApiClientInitOptions

export const ApiClientProvider = ({
  children,
  auth,
  platformApiDomain,
  service,
}: PropsWithChildren<ApiClientProviderProps>) => {
  const apiClient = useApiClientInit({ auth, platformApiDomain, service })

  return (
    <ApiClientContextProvider value={apiClient}>
      {children}
    </ApiClientContextProvider>
  )
}
